export default {
    ca: {
        searchBox: {
            searchPlaceholder: 'Escriu aquí...',
            showing: 'Mostrant',
            showingResults: 'resultats',
            rank: 'Popularitat',
            relevance: 'Nom',
            date: 'Data',
            noResults: 'No hi ha resultats per mostrar',
        },
    },
    es: {
        searchBox: {
            searchPlaceholder: 'Escribe aquí...',
            showing: 'Mostrando',
            showingResults: 'resultados',
            rank: 'Popularidad',
            relevance: 'Nombre',
            noResults: 'No hay resultados para mostrar',
        },
    },
    en: {
        searchBox: {
            searchPlaceholder: 'Type here...',
            showing: 'Showing',
            showingResults: 'results',
            rank: 'Rank',
            relevance: 'By name',
            date: 'Date',
            noResults: 'There are no results to display',
        },
    },
};



// WEBPACK FOOTER //
// ./src/gallery/components/gallery-list/gallery-list-translations.js